module.exports = __webpack_public_path__ + "static/media/resume.664055e0.jpg";